import { Grid } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { forwardRef, useContext } from "react";
import { BentoBrand } from "schemas/dashboard";

import SkeletonBrand from "features/Home/Sidebar/FavoritesList/SkeletonBrand";

import SelectedBrand from "./SelectedBrand";

const REF_OFFSET = 9;

interface IProps {
  displayedBrands: BentoBrand[];
  loading: boolean;
  handleSelect: (bentoBrand: BentoBrand) => void;
  selectedBrandIds: Set<number>;
  selectAll: boolean;
}

const BrandList = forwardRef(
  (
    {
      displayedBrands,
      loading,
      handleSelect,
      selectedBrandIds,
      selectAll,
    }: IProps,
    ref,
  ) => {
    const { subscription } = useContext(SubscriptionContext);
    return (
      <Grid container>
        {displayedBrands.map((bentoBrand: BentoBrand, index: number) => (
          <SelectedBrand
            key={bentoBrand.id}
            ref={
              (
                REF_OFFSET > displayedBrands.length
                  ? displayedBrands.length - 1 === index
                  : displayedBrands.length - REF_OFFSET === index
              )
                ? ref
                : null
            }
            bentoBrand={bentoBrand}
            handleSelect={handleSelect}
            isSelected={
              selectedBrandIds.has(bentoBrand.id) ||
              (selectAll && index < subscription?.remainingMessages!)
            }
          />
        ))}
        {loading && (
          <>
            <SkeletonBrand />
            <SkeletonBrand />
            <SkeletonBrand />
          </>
        )}
      </Grid>
    );
  },
);

export default BrandList;
